var map = {
	"./Betting.js": "QcLk",
	"./CustomerService.js": "wOv4",
	"./Deposit.js": "OiRm",
	"./Discount.js": "eBOH",
	"./My.js": "lvml"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PmHz";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/router/module \.js$
// module id = PmHz
// module chunks = 74